import * as React from 'react';

import AccountDropdownGridItemModule from 'bundles/composable-page-header/components/grid-items/account-dropdown/AccountDropdownGridItemModule';

// This is a super simple dropdown only used in the checkout page, where we don't want to distract learners from completing their purchase.
const DefaultAccountDropdownGridItemRenderer = ({
  isCourseraPlusLearner,
}: {
  isCourseraPlusLearner: boolean | null | undefined;
}) => {
  return <AccountDropdownGridItemModule isCourseraPlusLearner={!!isCourseraPlusLearner} />;
};

export default DefaultAccountDropdownGridItemRenderer;
